<div class="popup-container">
  <p>
    {{'menuPanel.createItem.info' | translate}}
  </p>
</div>
